import gql         from 'graphql-tag'

export const query = {
  getAll: (client, resource, fetch,variables ) =>
    client.query({
      query:gql`{
        ${resource},
      }`,
      variables,
    fetchPolicy: fetch ? fetch : 'network-only',
  }),

  getUnit: (client, resource, variables, fetch ) =>
    client.query({
      query: gql`
          ${resource}
        `,
      variables,
      fetchPolicy: fetch ? fetch : 'network-only',
    }),
}

export const mutation = (client, resource, variables) =>
  client.mutate({
    mutation: gql`
      ${resource}
    `,
    variables,
  })